import { TemplateService } from '../../services/template.service';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import { ApiService } from '../../services/api.service';
import { HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../services/constant';
var EmailDashboardComponent = (function () {
    function EmailDashboardComponent(apiService, translate, template) {
        this.apiService = apiService;
        this.translate = translate;
        this.template = template;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.emailSent = 0;
        this.emailSendFailed = 0;
        this.allBuyerEmailsReport = null;
        this.loading_main = false;
        this.tableData = [];
        this.selectedCompany = null;
        this.branchList = null;
        this.selectedBranch = null;
        this.allBranchList = null;
        this.startDate = null;
        this.endDate = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.sortBy = null;
        this.sortMode = null;
        this.sentdata = null;
        this.searching = false;
        this.tableCol = [];
    }
    EmailDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.loadInitData();
            _this.searchButtonClicked();
        });
        this.loadInitData();
        this.searchButtonClicked();
    };
    Object.defineProperty(EmailDashboardComponent.prototype, "currentLang", {
        get: function () {
            return this.translate.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    EmailDashboardComponent.prototype.generateChart = function () {
        this.sentChart = new Chart('sentChart', {
            type: 'doughnut',
            data: {
                datasets: [{
                        label: 'Sent Chart',
                        data: [this.emailSent, this.emailSendFailed],
                        backgroundColor: [
                            '#16c8c8',
                            '#5b5a5a',
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                responsive: true,
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.errorChart = new Chart('errorChart', {
            type: 'doughnut',
            data: {
                datasets: [{
                        label: 'Failed Chart',
                        data: [this.emailSendFailed, this.emailSent],
                        backgroundColor: [
                            '#FF6384',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
    };
    EmailDashboardComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = '';
        }
        else {
            this.sortMode = '-';
        }
    };
    EmailDashboardComponent.prototype.pageChanged = function () {
        this.sentdata = 1;
        this.loadData(this.currentPage);
    };
    EmailDashboardComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.status = null;
        this.loadData();
    };
    EmailDashboardComponent.prototype.loadInitData = function () {
        var _this = this;
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.loading_main = true;
        this.rdDocumentType = this.template.getDropdown();
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
            _this.company = _.uniqBy(_this.company, 'label');
        }, function (error) { return error(status); });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        this.apiService.getAllBuyerEmailsReport().subscribe(function (result) {
            _this.allBuyerEmailsReport = result.all_buyer_emails_report;
        });
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            _this.tableCol = [];
            _this.tableCol.push({ field: 'created_at', header: _this.translate.instant('EMAIL-DASHBOARD.SENT-DATE') }, { field: 'tax_data__header_invoice_number', header: _this.translate.instant('FILTER.DOCUMENT-NUMBER') }, { field: 'tax_data__rd_document_type', header: _this.translate.instant('FILTER.DOCUMENT-TYPE') });
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
        });
    };
    EmailDashboardComponent.prototype.filterStatus = function (data) {
        this.currentPage = 1;
        this.status = data;
        this.loadData(this.currentPage, this.status);
    };
    EmailDashboardComponent.prototype.loadData = function (page, data) {
        var _this = this;
        this.tableData = [];
        var params = new HttpParams();
        if (this.selectedCompany && this.selectedRdDocumentType) {
            params = params.append('corporate', this.selectedCompany);
            params = params.append('document_type', this.selectedRdDocumentType);
        }
        if (this.status) {
            params = params.append('status', this.status);
        }
        if (this.selectedCompany) {
            params = params.append('corporate', this.selectedCompany);
        }
        if (this.selectedBranch) {
            params = params.append('corporate_branch', this.selectedBranch);
        }
        if (this.selectedRdDocumentType) {
            params = params.append('document_type', this.selectedRdDocumentType);
        }
        if (this.documentNumber) {
            params = params.append('document_number', this.documentNumber);
        }
        if (this.email) {
            params = params.append('email', this.email);
        }
        if (this.sentdata) {
            params = params.append('page', this.currentPage.toString());
            params = params.append('page_size', this.itemsPerPage.toString());
        }
        if (this.startDate) {
            params = params.append('start_date', moment(this.startDate).format('YYYY-MM-DD'));
        }
        if (this.endDate) {
            params = params.append('end_date', moment(this.endDate).format('YYYY-MM-DD'));
        }
        if (this.sortBy) {
            params = params.append('ordering', this.sortMode + this.sortBy);
        }
        this.apiService.getEmailDashboard(params).subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.tableData.push({
                    sent_date: obj.sent_date,
                    document_number: obj.document_number,
                    document_type: obj.document_type_display,
                    document_type_th: obj.document_type_display_th,
                    to_email_data: obj.to_email,
                    cc_email_data: obj.cc_email,
                    status: obj.status,
                });
            });
            _this.totalItems = result.count;
            _this.emailSent = result.email_sent;
            _this.emailSendFailed = result.email_failed;
            _this.emailTotal = result.email_sent + result.email_failed;
            _this.transactions_sent = result.transactions_sent;
            _this.transactions_failed = result.transactions_failed;
            _this.transactions_wait_for_send = result.transactions_wait_for_send;
            _this.transactions_not_sent = result.transactions_not_sent;
            _this.loading_main = false;
            if (!_this.sentChart && !_this.errorChart) {
                _this.generateChart();
            }
            else {
                _this.sentChart.destroy();
                _this.errorChart.destroy();
                _this.generateChart();
            }
            _this.loading_main = false;
        });
        this.loading_main = false;
    };
    Object.defineProperty(EmailDashboardComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailDashboardComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    EmailDashboardComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    EmailDashboardComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    EmailDashboardComponent.prototype.clearData = function () {
        this.transactions_failed = null;
        this.transactions_wait_for_send = null;
        this.transactions_not_sent = null;
        this.transactions_sent = null;
        this.tableData = null;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.rdDocumentType = null;
        this.branchList = null;
        this.company = null;
        this.selectedCompany = null;
        this.selectedRdDocumentType = null;
        this.email = null;
        this.sortBy = null;
        this.sortMode = null;
        this.totalItems = 0;
        this.currentPage = 1;
        this.selectedBranch = null;
        this.documentNumber = null;
        this.loadInitData();
        this.searchButtonClicked();
    };
    EmailDashboardComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany === null || obj.corporate === _this.selectedCompany) {
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
            }
        });
    };
    EmailDashboardComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    EmailDashboardComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return EmailDashboardComponent;
}());
export { EmailDashboardComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.ts.pre-build-optimizer.js